//
//
//
//
//
//
//
//

	import SVGA from "svgaplayerweb";
	export default {
		name: 'boxfall',
		props: {
			fall_svga: {
				type: String
			}
		},
		data() {
			return {
				ground: new Audio(require('../../../resources/audio/fall.mp3'))
			}
		},
		methods: {
			load() { //初始
				this.player = new SVGA.Player("#fallCanvas")
				this.parser = new SVGA.Parser("#fallCanvas")
				let new_svga = this.fall_svga
				this.parser.load(new_svga, (videoItem) => {
					this.player.loops = 1
					this.player.clearsAfterStop = false
					this.player.setVideoItem(videoItem)
					this.player.stepToFrame(0, false)
					this.$emit('initial')
				})
			},


			stepToFrame() { //重置
				this.player.stepToFrame(0, false)
			},

			start() { //开始播放

				this.player.startAnimation()
				this.ground.play()
				this.player.onFinished(() => {
					this.$emit('finish')
				})
			}
		},
		watch: {
			fall_svga(v) {
				if (v) this.load()
			}
		}
	}
